/* eslint-disable max-params */
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { CommandContribution, CommandRegistry } from '@patsnap/tahiti-core';
import { createDialog } from '@patsnap/tahiti-core';
import type { ClaimAnalysisResult, FeatureComparisonResult } from '@/domains/fto-pro/apis/fto-pro-api';

export interface ClaimCompareDialogPayload {
    patentId?: string;
    claimAnalysisResults?: ClaimAnalysisResult[];
    defaultOpenDrawer?: boolean;
    editable?: boolean;
}

export interface PatentTechnicalFeatureDetailDrawerPayload {
    claimAnalysisResult: ClaimAnalysisResult;
    defaultSelectedTechFeature?: FeatureComparisonResult;
    technicalProposal?: string;
    editable?: boolean;
}

const claimCompareDialogService = createDialog(() => import('@/presentation/pages/fto-pro/components/FeatureCompare/ClaimFeatureCompareDialog.vue'));
const patentTechnicalFeatureDetailDrawerService = createDialog(() => import('@/presentation/pages/fto-pro/components/PatentDetailDrawer/PatentDetailDrawer.vue'));

@injectable()
export class FtoProCommandContribution implements CommandContribution {
    registerCommands(commands: CommandRegistry): void {
        commands.registerCommand({
            id: 'ftoPro:open-claim-compare-dialog',
        }, {
            execute: (payload: ClaimCompareDialogPayload) => claimCompareDialogService().open(payload),
        });
        commands.registerCommand({
            id: 'ftoPro:open-patent-technical-feature-detail-drawer',
        }, {
            execute: (payload: PatentTechnicalFeatureDetailDrawerPayload) => patentTechnicalFeatureDetailDrawerService().open(payload),
        });
    }
}


declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        /**
         * 打开权利要求对比对话框
         * @param commandId - 命令ID
         * @param payload - 对话框参数
         */
        executeCommand(commandId: 'ftoPro:open-claim-compare-dialog', payload: ClaimCompareDialogPayload): ClaimAnalysisResult[];
        /**
         * 打开专利技术特征详情抽屉
         * @param commandId - 命令ID
         */
        executeCommand(commandId: 'ftoPro:open-patent-technical-feature-detail-drawer', payload: PatentTechnicalFeatureDetailDrawerPayload): ClaimAnalysisResult[];
    }
}
